import React from 'react';
import CandidateDetails from '../../Home/Candidates/CandidateDetails';

const AppliedCandidateView = () => {
  return <CandidateDetails />;
};

export default AppliedCandidateView;